import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VOverlay,{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],attrs:{"opacity":"0.9","color":"white","absolute":""}},[_c(VProgressCircular,{attrs:{"indeterminate":"","color":"secondary"}})],1),_c('pdf',{attrs:{"src":_vm.pdfUrl,"page":1},on:{"loaded":_vm.onLoaded,"error":_vm.onError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }